import { Autocomplete, TextField } from "@mui/material";
import Header from "components/Headers/Header";
import ReuseableTable from "components/Tables/ReuseableTable";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Container,
  Card,
  CardBody,
  Input,
  Button,
  Form,
  Table,
  Modal,
  ModalBody,
  Row,
  Label,
  Spinner,
} from "reactstrap";
import { newCollegeUniversitiesData } from "store/actions/athleteActions";
import { getCollegeCity } from "store/actions/athleteActions";
import { fetchStates } from "store/actions/athleteActions";
import { updateSportRequest } from "store/actions/requestedSportsAction";
import { createSportRequest } from "store/actions/requestedSportsAction";
import { getSportRequest } from "store/actions/requestedSportsAction";
import { getAllUsers } from "store/actions/userAction";

const RequestedSports = () => {
  let dispatch = useDispatch();
  const [modal, setModal] = useState(false);
  const [modalPosition, setModalPosition] = useState(false);
  const [sport, setSport] = useState("");
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [loadMoreLoader, setLoadMoreLoader] = useState(false);
  const [college, setCollege] = useState("");
  let { uid } = useSelector((state) => state.auth);
  let { allUsers } = useSelector((state) => state.users);
  let { sportRequests, hasMoreDocument, lastDocument } = useSelector(
    (state) => state.requestedSports
  );
  const [support, setSupport] = useState([]);
  const [loader, setLoader] = useState();
  const [inputList, setInputList] = useState([{ category: "", meaning: "" }]);
  const { states, cities, collegeInstitutes } = useSelector(
    (state) => state.athlete
  );
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);
  const newSport = sport.toLowerCase().split(" ");
  for (let i = 0; i < newSport.length; i++) {
    newSport[i] = newSport[i][0]?.toUpperCase() + newSport[i].substr(1);
  }

  const [data, setData] = useState([]);

  const toggle = () => {
    setModal(!modal);
    setState("");
    setCity("");
    setSport("");
    setCollege("");
  };

  const handlePositionToggle = () => {
    setModalPosition(!modalPosition);
  };

  const loadMore = () => {
    if (!hasMoreDocument) return;
    setLoadMoreLoader(true);
    dispatch(
      getSportRequest(lastDocument, () => {
        setLoadMoreLoader(false);
      })
    );
  };

  useEffect(() => {
    setLoader(true);
    const unsubscribe = dispatch(
      getSportRequest("", () => {
        setLoader(false);
      })
    );
    return () => {
      if (unsubscribe && typeof unsubscribe === "function") unsubscribe();
    };
  }, [dispatch]);

  useEffect(() => {
    let unsubscribe;
    if (allUsers.length == 0) {
      unsubscribe = dispatch(getAllUsers());
    }
    return () => {
      if (unsubscribe && typeof unsubscribe === "function") unsubscribe();
    };
  }, [dispatch, allUsers.length]);

  const handleHeartClick = (id, arr) => {
    if (arr.includes(uid)) {
      let checkedArr = arr.filter((item) => item !== uid);
      dispatch(updateSportRequest(id, checkedArr));
    } else {
      let obj = [...arr, uid];
      dispatch(updateSportRequest(id, obj));
    }
  };

  useEffect(() => {
    if (states.length == 0) {
      dispatch(fetchStates());
    }
  }, [dispatch, states.length]);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (state != "") {
      dispatch(getCollegeCity(state));
    }
  }, [state]);

  useEffect(() => {
    if (state != "" && city != "") {
      dispatch(newCollegeUniversitiesData(state, city));
    }
  }, [state, city]);

  const defaultStateProps = {
    options: states?.map((insti) => {
      return insti.name;
    }),
    getOptionLabel: (option) => option,
  };

  const defaultCollegeProps = {
    options: cities?.map((insti) => {
      return insti.city;
    }),
    getOptionLabel: (option) => option,
  };

  let newSchools = [];
  const getInstitutes = () => {
    collegeInstitutes.forEach((insti) => {
      insti.institutes?.forEach((ele) => {
        newSchools.push(ele);
      });
    });

    if (newSchools) {
      return newSchools;
    }
  };
  const defaultSchoolProps = {
    options: getInstitutes(),
    getOptionLabel: (option) => option,
  };

  const TABLE_DATA = {
    columns: [
      "Sport",
      "My School’s Name",
      "Status",
      "My School’s Location",
      "Support",
    ],
    keyMap: {
      Sport: "sport",
      "My School’s Name": "mySchoolsName",
      Status: "status",
      "My School’s Location": "mySchoolsLocation",
      Support: "support",
    },
    data: sportRequests.map((row, index) => {
      return {
        sport: row.sport,
        mySchoolsName: row.college,
        status: row.status,
        mySchoolsLocation: row.state + "," + row.city,
        support: (
          <div className="d-flex justify-content-center">
            <i
              className={
                row.supported_by.includes(uid)
                  ? "fas fa-heart fa-2x text-danger pointer"
                  : "fas fa-heart fa-2x  pointer"
              }
              onClick={() => handleHeartClick(row.id, row.supported_by)}
            ></i>
            <p className="pl-2">{row.support}</p>
          </div>
        ),
      };
    }),
  };

  return (
    <>
      <Header />

      <Modal isOpen={modal}>
        <ModalBody>
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              let obj = {
                details: inputList,
                sport: newSport.join(""),
                state: state,
                city: city,
                college: college,
                status: "pending",
                added_by: uid,
                supported_by: support,
                support: support.length,
              };
              setLoader(true);
              dispatch(createSportRequest(obj)).then(() => {
                toggle();
                setSport("");
                setState("");
                setCollege("");
                setCity("");
                setInputList([{ category: "", meaning: "" }]);
                setLoader(false);
              }).catch(() => {
                setLoader(false);
              });
            }}
          >
            <>
              <p className="auth-desc-subtitle mt-0 ml-0">
                Add Requested Sport
              </p>
              <div>
                <Label className="m-0 text-center">
                  <h3>State:</h3>
                </Label>
                <Autocomplete
                  {...defaultStateProps}
                  id="auto-complete"
                  autoComplete
                  includeInputInList
                  disableClearable={true}
                  disableListWrap
                  value={state}
                  onChange={(e, val) => {
                    setState(val);
                    setCity("");
                    setCollege("");
                    setSport("");
                  }}
                  renderInput={(params) => (
                    <TextField {...params} variant="standard" />
                  )}
                />
              </div>
              <div>
                <Label className="mt-2 text-center">
                  <h3>City:</h3>
                </Label>
                <Autocomplete
                  {...defaultCollegeProps}
                  id="auto-complete"
                  autoComplete
                  includeInputInList
                  disableClearable={true}
                  disableListWrap
                  value={city}
                  onChange={(e, val) => {
                    setCity(val);
                    setCollege("");
                    setSport("");
                  }}
                  renderInput={(params) => (
                    <TextField {...params} variant="standard" />
                  )}
                />
              </div>
              <div className="mt-3">
                <Label className="m-0 text-center">
                  <h3>School:</h3>
                </Label>
                <Autocomplete
                  {...defaultSchoolProps}
                  id="auto-complete"
                  autoComplete
                  includeInputInList
                  disableClearable={true}
                  disableListWrap
                  value={college}
                  onChange={(e, val) => {
                    setCollege(val);
                    setSport("");
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="standard"
                      inputProps={{
                        ...params.inputProps,
                        readOnly: true,
                      }}
                    />
                  )}
                />
              </div>

              <div className="mt-3">
                <Label className="m-0 text-center">
                  <h3>Sport:</h3>
                </Label>
                <Input
                  type="text"
                  value={sport}
                  style={{
                    border: "none",
                    borderRadius: "0px",
                    height: "32px",
                    borderBottom: "1px solid rgba(0, 0, 0, 0.42)",
                    color: "black",
                  }}
                  onChange={(e) => setSport(e.target.value)}
                />
              </div>
              <div className="text-right">
                <Button
                  color="primary"
                  size="md"
                  className="mt-4"
                  type="submit"
                  disabled={
                    !sport ||
                    !city ||
                    !college ||
                    !state ||
                    !inputList ||
                    loader
                  }
                >
                  {loader ? <Spinner size="sm" /> : "Submit"}
                </Button>
                <Button className="mt-4" color="danger" onClick={toggle}>
                  Close
                </Button>
              </div>
            </>
          </Form>
        </ModalBody>
      </Modal>
      <Container className="mt--4" fluid>
        <h2 className="text-dark mb-4 font-weight-700" style={{ fontSize: isSmallScreen ? "18px" : "26px" }}>
          My favorite sport not listed. Please add it.
        </h2>
        <Card className="shadow border-0 rounded-4 p-4">
          <div className="d-flex align-items-center mb-3">
            <h3 className="mb-0 text-dark font-weight-700">
              Sports
            </h3>
            <Button className="ml-auto" color="primary" onClick={toggle}>
              Add New Sport
            </Button>
          </div>
          {loader ? (
            <div className="d-flex justify-content-center align-items-center py-5">
              <Spinner size="md" color="primary" />
            </div>
          ) : (
            <>
              <ReuseableTable {...TABLE_DATA} emptyMessage="No sport requests submitted yet." />
              <div className="w-100  p-3 d-flex justify-content-center">
                {sportRequests.length > 4 && hasMoreDocument && (
                  <div className="text-center">
                    <Button
                      color="primary"
                      onClick={loadMore}
                      disabled={loadMoreLoader}
                    >
                      {loadMoreLoader ? <Spinner size="sm" /> : "Load more"}
                    </Button>
                  </div>
                )}
              </div>
            </>
          )}
        </Card>
      </Container>

      <Modal isOpen={modalPosition}>
        <ModalBody>
          <p className="auth-desc-subtitle mt-0 ml-0 pl-3 mb-0">
            Sport Details
          </p>
          <Table className="align-items-center table-flush" responsive>
            <thead>
              <tr>
                <th scope="col" className="custom-table-heading custom-heading">
                  Sport Category
                </th>
                <th
                  scope="col"
                  className="custom-table-heading custom-heading text-center"
                >
                  Category Name
                </th>
              </tr>
            </thead>
            <tbody className="custom-table-body mt-3">
              {sportRequests.length > 0 &&
                data.map((ele, index) => (
                  <tr>
                    <td className={"custom-table-text"}>{ele.category}</td>
                    <td className="custom-table-text" align="center">
                      {ele.meaning}
                    </td>
                  </tr>
                ))}
            </tbody>
          </Table>
          <div className="text-right">
            <Button
              className="mt-4"
              color="danger"
              onClick={handlePositionToggle}
            >
              Close
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default RequestedSports;
